import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withKeys as _withKeys, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["aria-pressed", "tabindex"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "button-square__p"
}

import { toRefs, ref, computed } from 'vue'
import ButtonSquareHoverCheckbox from './ButtonSquareHoverCheckbox.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonSquareHoverChecklist',
  props: {
    activeState: { default: 'inactive' },
    activeHoverButtonValue: { default: '' },
    hoverButtonActiveState: { default: 'inactive' },
    hoverButtonTitle: { default: '' },
    hoverButtons: { default: () => [] },
    hoverExplanationText: { default: 'undefined' },
    imgSource: { default: '' },
    isDarkMode: { type: Boolean, default: false },
    isInMenu: { type: Boolean, default: false },
    showLoadingSpinner: { type: Boolean, default: false },
    size: { default: 'medium' },
    title: { default: '' }
  },
  emits: ["onChecklistToggle", "clicked", "hovered", "mouseenter", "mouseleave"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const { activeState, size, title } = toRefs(props)
const emits = __emit
const showHoverButton = ref(false)
const showHoverExplanationText = ref(false)
const hasTitle = computed(() => size.value === 'large' && title.value)
// function activeStateForHoverButton(button: any) {
//   //seems to not be used, do we need it?
//   activeHoverButtonValue.value === button.emit ? 'active' : 'inactive'
// }
function onClick() {
  emits('clicked')
}
function onHover() {
  if (activeState.value !== 'deactivated') {
    showHoverButton.value = true
    showHoverExplanationText.value = true
    emits('hovered')
  }
}
function onLeave() {
  showHoverButton.value = false
  showHoverExplanationText.value = false
  emits('mouseleave')
}
function onToggle(id: string | number, disabled: boolean) {
  if (disabled) return
  emits('onChecklistToggle', id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onMouseover: onHover,
    onMouseleave: onLeave
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hoverButtons, (b) => {
      return _withDirectives((_openBlock(), _createBlock(ButtonSquareHoverCheckbox, {
        key: b.id,
        checkboxData: b,
        onToggle: ($event: any) => (onToggle(b.id, b.disabled))
      }, null, 8, ["checkboxData", "onToggle"])), [
        [_vShow, (_ctx.hoverButtons.length && showHoverButton.value) || _unref(activeState) === 'active']
      ])
    }), 128)),
    _createElementVNode("div", {
      "aria-pressed": _unref(activeState) === 'active',
      class: _normalizeClass([{
        'button-square--active': _unref(activeState) === 'active',
        'button-square--dark': _ctx.isDarkMode,
        'button-square--deactivated': _unref(activeState) === 'deactivated',
        'button-square--large': _unref(size) === 'large',
        'button-square--small': _unref(size) === 'small',
        'button-square--text': hasTitle.value
      }, "button-square"]),
      role: "button",
      tabindex: _unref(activeState) === 'deactivated' ? -1 : 0,
      onClick: onClick,
      onKeydown: [
        _withKeys(onClick, ["enter"]),
        _withKeys(onClick, ["space"])
      ],
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('mouseenter'))),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('mouseleave')))
    }, [
      _createVNode(PulseLoader, {
        loading: _ctx.showLoadingSpinner,
        class: "spinner",
        color: "#949494"
      }, null, 8, ["loading"]),
      (!_ctx.showLoadingSpinner)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.imgSource,
            class: _normalizeClass(["button-square__img", { 'button-square__img--text': hasTitle.value }])
          }, null, 10, _hoisted_2))
        : _createCommentVNode("", true),
      (hasTitle.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(title)), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 42, _hoisted_1)
  ], 32))
}
}

})